import ServiceMaintainenceIcon from '../../images/homePageImages/serviceIcons/serviceMaintainance.png'
import TwoD3dIcon from '../../images/homePageImages/serviceIcons/2D3D.png'
import GraphicDesignIcon from '../../images/homePageImages/serviceIcons/graphicDesign.png'
import MobileAppIcon from '../../images/homePageImages/serviceIcons/mobileApp.png'
import CustomSoftwareIcon from '../../images/homePageImages/serviceIcons/customSoftware.png'
import HardwareMaintanenceIcon from "../../images/homePageImages/serviceIcons/hardwareMaintainenceApp.png"
import ShortFilmIcon from "../../images/homePageImages/serviceIcons/shortFilm.png"
import EContentIcon from "../../images/homePageImages/serviceIcons/eContent.png"
import HardSupport from "../../images/homePageImages/serviceIcons/hardwareSupport.png"



export default {
    about : "an information technology based company since 2004, in Education and Training, is offering wide range of that include creating educational and training content of global relevance,designing and executing large learning initiatives and setting up the requisite infrastructure. Netcom providing multiple software services to clients. Our mission is   to help customers achieve their business objectives by providing    innovative, best-in-class consulting, IT solutions, and services. We    function as an IT partner to business, offering a consulting – plan –    implementation approach with an integrated portfolio of technology IT    solutions that encompass the entire Enterprise value chain.",        
    serviceContent :  [
        {
          title: "Graphic Design",
          link:'/graphic-design',
          icon: GraphicDesignIcon,
          content:
            "With A Team Of Creative Design Professionals, We Support Our Clients To Enter Into The Global Business Market With Trendy And Eye-Catching Designs",
        },
        {
          title: "E Content Development",
          link:'/e-content-development',
          icon: EContentIcon,
          content:
            "Comprehensive digital repository offering superior-quality content in Mathematics, Physics, Chemistry, Biology, Social Sciences, English Grammar, Business Studies, Economics and Accountancy",
        },
        {
          title: "Short Film",
          link:'/short-film',
          icon: ShortFilmIcon,
          content:
            "We make Short Films, Ads, 2D and 3D Animations",
        },
        {
          title: "Web Application Development",
          link:'/web-app-development',
          icon:TwoD3dIcon,
          content:
            "A Composed Team Of Pre-Eminent And Rapid Working Web Development Professionals Are In Netcom",
        },
        {
          title: "Mobile Application Development",
          link:'/mob-app-development',
          icon: MobileAppIcon,
          content:
            "With A Great Fame, Best Working Mobile Apps Are Warm Welcomed. In That Line, Apps From Netcom Has Received Great Response From Our Clients",
        },
        {
          title: "Web Hosting Services",
          link:'/web-hosting',
          icon: ServiceMaintainenceIcon,
          content:
            "Includes software upgrades, repairs and fixes. We will also monitor the performance of the software so you don’t face any issues",
        },
        {
          title: "Customized Software Development",
          link:'/custom-app-development',
          icon: CustomSoftwareIcon,
          content:
            "Aim to provide you the exact services and solutions you have asked for, because we value your product!",
        },
        {
          title: "Hardware Support & Maintainance",
          link:'/hardware-support-maintainence',
          icon: HardSupport,
          content:
            "Aim to provide you the exact services and solutions you have asked for, because we value your product!",
        },
        {
          title: "Cloud Maintainance",
          link:'',
          icon: HardwareMaintanenceIcon,
          content:
            "Aim to provide you the exact services and solutions you have asked for, because we value your product!",
        }
      ],

   
  }
 